import { render, staticRenderFns } from "./CompanyListItem.vue?vue&type=template&id=4a35cadc&"
import script from "./CompanyListItem.vue?vue&type=script&lang=js&"
export * from "./CompanyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompanyListItem.vue"
export default component.exports